<template>
    <div style="width:100%;float:left;">
      <CCard>
        <CCardHeader>Failed Jobs</CCardHeader>
        <CCardBody>
          <CDataTable
            v-if="items"
            :items="items"
            :fields="fields"
            column-filter
            table-filter
          >
            <template #ref="{item}">
              <td>
                <span v-if="item.log_number">{{ item.log_number }}</span>
              </td>
            </template>
            <template #actions="{item}">
              <td>
                <CButton size="sm" color="info" class="mr-1" @click="viewError(item)">View</CButton>
                <CButton size="sm" color="success" @click="submitJob(item)">Retry Job</CButton>
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCard>

      <CModal
        title="Error Message"
        :show.sync="errorModal"
      >
        <div style="width:100%;float:left;" v-if="errorItem">
          {{ errorItem.exception }}
        </div>
        <template #footer>
          <CButton @click="errorItem = '', errorModal = false" color="danger">Close</CButton>
          <CButton @click="submitJob(errorItem)" color="success">Retry Job</CButton>
        </template>
      </CModal>
    </div>
  </template>
  <script>

  var methods = {}

  methods.viewError = function (item) {
    console.log(item)
    // this.errorItem = item
    // this.errorModal = true
    const postData = {
      item: item
    }
    axios.post(this.$apiAdress + '/api/getFailedException?token=' + localStorage.getItem('api_token'), postData).then(response => {
      console.log(response)
      this.errorItem = response.data
      this.errorModal = true
    })
  }

  methods.getFailedJobs = function () {
    axios.get(this.$apiAdress + '/api/getFailedJobs?token=' + localStorage.getItem('api_token')).then(response => {
      console.log(response)
      this.items = response.data
    })
  }

  methods.submitJob = function (item) {
    const postData = {
      job_id: item.id
    }
    axios.post(this.$apiAdress + '/api/retryJob?token=' + localStorage.getItem('api_token'), postData).then(response => {
      console.log(response)
      Swal.fire("Submitted.", "You have submitted the job id #" + item.id, "success")
    })
  }
  
  export default {
    // ===Component name
    name: "FailedJobsTable",
    // ===Props passed to component
    props: {},
    // ===Components used by this component
    components: {
  
    },
    // ====component Data properties
    data(){
        return{
          items: '',
          fields: ['id', 'ref', 'actions'],
          errorItem: '',
          errorModal: false
        }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
      this.getFailedJobs()
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
  }
  </script>
  <!-- styles -->
  <!-- adding scoped attribute will apply the css to this component only -->
  <style scoped></style>
  